'use client';

import Image from 'next/image';
import parse from 'html-react-parser';

type HeroProps = {
  title: string;
  subtitle: string;
  image: string;
};

const Hero = ({ title, subtitle, image }: HeroProps) => {
  return (
    <section className={'hero'}>
      <div className="hero-container">
        <div className="hero-content">
          <h1>{parse(title)}</h1>
          <p className="subhead">{subtitle as string}</p>
        </div>
        <div className="hero-image-container">
          <Image
            src={image}
            width={580}
            height={411}
            alt=""
            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
            sizes="100vw"
            priority
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
